import {Table, TableBody, TableCell, TableHead, TableRow, makeStyles} from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';
import {AvailStringField, StringComparingComponent} from '../../../../value-comparing/helper-components';
import {ValueComparer} from '../../../../value-comparing/value-comparer';

const valueComparer = new ValueComparer();

const arrayKeys = ['territory', 'territoryExcluded', 'refALID', 'holdbackLanguage', 'assetLanguage', 'allowedLanguage'];

const timeStampKeys = ['start', 'end'];

const RenderTransactionObjectTypeValue = ({value, oldValue}) => (
  <>
    {Object.keys(value).map(key => (
      <AvailStringField assignedKey={key} key={key} oldValue={oldValue?.[key]} value={value[key]} />
    ))}
  </>
);

RenderTransactionObjectTypeValue.propTypes = {
  oldValue: PropTypes.object || PropTypes.array,
  value: PropTypes.object || PropTypes.array,
};

const renderDataCorrectly = (valueToRender, oldValue, currentKey) => {
  if (arrayKeys.includes(currentKey)) {
    return valueToRender.map((value, index) => (
      <RenderTransactionObjectTypeValue key={index} oldValue={oldValue && oldValue[index]} value={value} />
    ));
  }

  if (timeStampKeys.includes(currentKey)) {
    const formattedDate = new Date(valueToRender).toLocaleDateString('en-us', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      timeZoneName: 'short',
    });
    const previousFormattedDate =
      oldValue &&
      new Date(oldValue).toLocaleDateString('en-us', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        timeZoneName: 'short',
      });
    return <StringComparingComponent current={formattedDate} key={currentKey} previous={previousFormattedDate} />;
  }

  if (valueComparer.isValue(valueToRender)) {
    return <StringComparingComponent current={valueToRender} key={currentKey} previous={oldValue} />;
  }

  if (currentKey === 'term') {
    return (
      <>
        <RenderTerms key={currentKey} oldValue={oldValue} termsCollection={valueToRender} />
      </>
    );
  }

  return <RenderTransactionObjectTypeValue key={currentKey} oldValue={oldValue} value={valueToRender} />;
};

const TransactionsSection = ({transactionCollection, oldValue}) => {
  const headKeys = Object.keys(transactionCollection[0]);
  return (
    <div style={{maxWidth: '100%', overflowX: 'scroll'}}>
      <h3>Transaction{transactionCollection.length > 1 ? 's' : ''}</h3>
      <Table>
        <TableHead>
          <TableRow>
            {headKeys.map(key => (
              <TableCell key={key}>
                <strong>{key}</strong>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {transactionCollection.map((transaction, index) => (
            <TableRow key={index}>
              {Object.keys(transaction).map(transactionKey => {
                const oldTransaction = oldValue && oldValue[index];

                return (
                  <TableCell key={transactionKey}>
                    {renderDataCorrectly(
                      transaction[transactionKey],
                      oldTransaction && oldTransaction[transactionKey],
                      transactionKey
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

TransactionsSection.propTypes = {
  oldValue: PropTypes.array,
  transactionCollection: PropTypes.array,
};

const useTermStyles = makeStyles(theme => ({
  termWrapper: {
    padding: `0 ${theme.spacing(0.5)}px`,
  },
}));

const RenderTerms = ({termsCollection, oldValue}) => {
  const classes = useTermStyles();
  const specialKeys = ['money', 'any', 'time', 'region'];

  return termsCollection.map((term, index) => {
    const {termName, ...termValues} = term;
    const oldTermValue = oldValue && oldValue[index];

    return (
      <div className={classes.termWrapper} key={index}>
        <p>
          <strong>{termName}</strong>
        </p>
        {Object.keys(termValues).map(termValueKey => {
          if (!specialKeys.includes(termValueKey)) {
            return (
              <AvailStringField
                assignedKey={termValueKey}
                key={termValueKey}
                oldValue={oldValue?.[termValueKey]}
                value={termValues[termValueKey]}
              />
            );
          }

          return (
            <ul key={termValueKey}>
              {Object.keys(termValues[termValueKey]).map(innerKey => (
                <li key={innerKey}>
                  <AvailStringField
                    assignedKey={innerKey}
                    oldValue={oldTermValue?.[termValueKey]?.[innerKey]}
                    value={termValues[termValueKey][innerKey]}
                  />
                </li>
              ))}
            </ul>
          );
        })}
      </div>
    );
  });
};

export default TransactionsSection;
